import { GET_CREDIT_LIMIT_MODEL_DATA_RESPONSE,GET_RECALCULATE_CREDIT_LIMIT_MODEL_AT_SECTION_RESPONSE,
    GET_SAVED_CREDIT_LIMIT_MODEL_AT_SECTION_RESPONSE } from './action';

const creditLimitEditSectionReducer = (state = {}, action) => {
    switch (action.type) {
        case GET_CREDIT_LIMIT_MODEL_DATA_RESPONSE:
            return {
                ...state,
                creditLimitModelParams: action.data
            }
        case GET_RECALCULATE_CREDIT_LIMIT_MODEL_AT_SECTION_RESPONSE:
            return {
                ...state,
                recalculatecreditLimitResponse: action.data
            } 
        case GET_SAVED_CREDIT_LIMIT_MODEL_AT_SECTION_RESPONSE:
            return {
                ...state,
                savecreditLimitResponse: action.data
            }        
        default:
            return state
    }
}

export default creditLimitEditSectionReducer;